export default __webpack_public_path__ + "static/media/pokedex-mb-grid.187c42e0.png";